import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators , FormArray} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../shared.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { OnlineApplicationService} from '../online_application.service'
import * as moment from 'moment';

@Component({
    selector: 'app-online-application-form',
    templateUrl: './online_application_form.component.html',
    styleUrls :["../../../modules/admissions/admission/css/image_view.css"]
})

export class OnlineApplicationFormComponent implements OnInit, OnDestroy {

    // currentSlide = 0

    constructor(
        private fb: UntypedFormBuilder,
        public translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private shareService: SharedService,
        private onlineApplicationService : OnlineApplicationService,
        private toastr: ToastrService,
    ) { }

    admission_status = true;
    admission_details : any;
    admission_form_fields = [];
    admission_form_field_keys = [];
    school_logo : any;

    public student_genders = ['Boy', 'Girl', 'Transgender']
    public guardian_genders = ['Male', 'Female', 'Transgender']
    public blood_groups = ['A+','A-','B+','B-','AB+','AB-','O+','O-','Other']

    student_form_image_priview = {
        student_photo : "",
        student_family_photo : "",
        guardian_photo : "",
        student_passport_size_photo : "",
        student_emirates_id_photo : "",
        student_passport_photo : "",
        guardian_emirates_id_photo : "",
        guardian_passport_photo : "",
    }

    student_form_image = []

    student_info: any;

    religions : any = [];
    nationalites : any = [];
    countries : any = [];
    relations : any = [];

    states : any = [];
    districts : any = [];
    cities : any = [];

    OnlineApplicationForm = this.fb.group({
        student_dob: [""],
        student_class : [""],

        student_name: [''],
        student_gender: [''],
        student_religion: [null],
        student_nationality: [null],
        student_email: ['', [Validators.email]],
        admission_date : [null],
        student_age: [null],
        student_id_no : [""],
        student_id_name : [""],
        aadhaar_no : [""],
        blood_group : [""],
        country_of_birth : [""],
        place_of_birth : [""],
        identification_mark : [""],
        hobbies : [""],
        mother_tongue : [""],
        is_disability : [""],
        disability : [""],
        height : [""],
        weight : [""],

        student_passport_no : [""],
        student_passport_issue_place : [""],
        student_passport_date_of_issue : [""],
        student_passport_date_of_expiry : [""],
        student_emirates_id : [""],
        student_emirates_id_expiry : [""],
        student_visa_no : [""],
        student_visa_expiry : [""],

        student_local_address : [""],
        student_local_state : [""],
        student_local_country : [""],
        student_local_district : [""],
        student_local_city : [""],
        student_local_zipcode : [""],

        student_permanent_address : [""],
        student_permanent_state : [""],
        student_permanent_country : [""],
        student_permanent_district : [""],
        student_permanent_city : [""],
        student_permanent_zipcode : [""],

        guardian_name : [""],
        guardian_age : [null],
        guardian_mobile_number : [null],
        guardian_qualification : [""],
        guardian_occupation : [""],
        guardian_designation : [""],
        guardian_name_of_organization : [""],
        guardian_address_of_organization : [""],
        guardian_state : [""],
        guardian_office_number : [""],
        guardian_telephone_number : [""],
        guardian_email : ["",[Validators.email]],
        guardian_dob : [""],
        guardian_nationality : [""],
        guardian_religion : [""],
        guardian_relation : [""],
        guardian_gender : [""],

        guardian_passport_no : [""],
        guardian_passport_issue_place : [""],
        guardian_passport_date_of_issue : [""],
        guardian_passport_date_of_expiry : [""],
        guardian_emirates_id : [""],
        guardian_emirates_id_expiry : [""],
        guardian_visa_no : [""],
        guardian_visa_expiry : [""],

        guardian_local_address : [""],
        guardian_local_state : [""],
        guardian_local_country : [""],
        guardian_local_district : [""],
        guardian_local_city : [""],
        guardian_local_zipcode : [""],

        guardian_permanent_address : [""],
        guardian_permanent_state : [""],
        guardian_permanent_country : [""],
        guardian_permanent_district : [""],
        guardian_permanent_city : [""],
        guardian_permanent_zipcode : [""],

        father_name : [""],
        father_age : [null],
        father_mobile_number : [null],
        father_qualification : [""],
        father_occupation : [""],
        father_designation : [""],
        father_name_of_organization : [""],
        father_address_of_organization : [""],
        father_country : [""],
        father_office_number : [""],
        father_telephone_number : [""],
        father_email : [""],
        father_dob : [""],
        father_nationality : [""],
        father_religion : [""],

        mother_name : [""],
        mother_age : [null],
        mother_mobile_number : [""],
        mother_qualification : [""],
        mother_occupation : [""],
        mother_designation : [""],
        mother_name_of_organization : [""],
        mother_address_of_organization : [""],
        mother_country : [""],
        mother_office_number : [""],
        mother_telephone_number : [""],
        mother_email : [""],
        mother_dob : [""],
        mother_nationality : [""],
        mother_religion : [""],

        grand_father : [""],
        grand_father_qualification : [""],
        grand_mother : [""],
        grand_mother_qualification : [""],

        prev_school_name : [""],
        prev_school_address : [""],
        prev_school_change_resaon : [""],
        prev_school_reg_no : [""],
        prev_mark : [""]
    })

    applicationFilesForm = this.fb.group({
        admission_files : this.fb.array([])
    })


    public images = []
    public currentSlide = 0;
    public enable_image_view = false;

    loaded = false;

    document_length = 0
    progress = 0
    fileUploadTimer : any;
    formfileUploadTimer : any;
    on_submit = false;


    get f(){
        return this.OnlineApplicationForm.controls;
    }

    get k(){
        return this.applicationFilesForm.controls;
    }

    get admission_files(){
        return this.applicationFilesForm.get("admission_files") as FormArray;
    }

    // addNewFile(){

    // }

    nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.images.length;
    }

    prevSlide() {
        this.currentSlide = this.currentSlide > 0 ? this.currentSlide - 1 : this.images.length - 1;
    }

    callNextSlide(){
        if(this.images?.length > 0){
            this.nextSlide();
        }
    }

    formatDate(date){
        if(date){
            return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }else{
            return null;
        }
    }

    generateDate(date){
        if(date){
            return new Date(date);
        }else{
            return null;
        }
    }

    updateDate(type){
        if(type == "submit"){
            this.OnlineApplicationForm.patchValue({
                admission_date : this.formatDate(this.OnlineApplicationForm.value["admission_date"]),
                student_passport_date_of_issue : this.formatDate(this.OnlineApplicationForm.value["student_passport_date_of_issue"]),
                student_passport_date_of_expiry : this.formatDate(this.OnlineApplicationForm.value["student_passport_date_of_expiry"]),
                student_emirates_id_expiry : this.formatDate(this.OnlineApplicationForm.value["student_emirates_id_expiry"]),
                student_visa_expiry : this.formatDate(this.OnlineApplicationForm.value["student_visa_expiry"]),
                guardian_dob : this.formatDate(this.OnlineApplicationForm.value["guardian_dob"]),
                guardian_passport_date_of_issue : this.formatDate(this.OnlineApplicationForm.value["guardian_passport_date_of_issue"]),
                guardian_passport_date_of_expiry : this.formatDate(this.OnlineApplicationForm.value["guardian_passport_date_of_expiry"]),
                guardian_emirates_id_expiry : this.formatDate(this.OnlineApplicationForm.value["guardian_emirates_id_expiry"]),
                guardian_visa_expiry : this.formatDate(this.OnlineApplicationForm.value["guardian_visa_expiry"]),
                father_dob : this.formatDate(this.OnlineApplicationForm.value["father_dob"]),
                mother_dob : this.formatDate(this.OnlineApplicationForm.value["mother_dob"])
            })
            this.submitApplication();
        }else{
            this.OnlineApplicationForm.patchValue({
                admission_date : this.generateDate(this.OnlineApplicationForm.value["admission_date"]),
                student_passport_date_of_issue : this.generateDate(this.OnlineApplicationForm.value["student_passport_date_of_issue"]),
                student_passport_date_of_expiry : this.generateDate(this.OnlineApplicationForm.value["student_passport_date_of_expiry"]),
                student_emirates_id_expiry : this.generateDate(this.OnlineApplicationForm.value["student_emirates_id_expiry"]),
                student_visa_expiry : this.generateDate(this.OnlineApplicationForm.value["student_visa_expiry"]),
                guardian_dob : this.generateDate(this.OnlineApplicationForm.value["guardian_dob"]),
                guardian_passport_date_of_issue : this.generateDate(this.OnlineApplicationForm.value["guardian_passport_date_of_issue"]),
                guardian_passport_date_of_expiry : this.generateDate(this.OnlineApplicationForm.value["guardian_passport_date_of_expiry"]),
                guardian_emirates_id_expiry : this.generateDate(this.OnlineApplicationForm.value["guardian_emirates_id_expiry"]),
                guardian_visa_expiry : this.generateDate(this.OnlineApplicationForm.value["guardian_visa_expiry"]),
                father_dob : this.generateDate(this.OnlineApplicationForm.value["father_dob"]),
                mother_dob : this.generateDate(this.OnlineApplicationForm.value["mother_dob"])
            })
        }
    }


    onSubmit() {
        if(this.OnlineApplicationForm.invalid){
            return this.toastr.error("Please fill all the fields!")
            return
        }
        this.checkFilesValidation();
        
    }

    checkFilesValidation(){
        for(let i = 0; i< this.admission_files?.length; i++){
            if(this.admission_files.at(i).value["mandatory"]){
                if(!this.admission_files.at(i).value["file"]){
                    this.toastr.error("Add Image of "+ this.admission_files.at(i).value["file_name"] )
                    return
                }
            }
        }
        this.updateDate("submit");
    }

    formSuccessfullComplete(message){
        clearInterval(this.fileUploadTimer)
        clearInterval(this.formfileUploadTimer)
        this.on_submit = false;
        Swal.fire({
            icon: 'success',
            text: this.translate.instant(message),
            confirmButtonText: 'Okay'
        })
        this.router.navigate(['school_application_form'])
    }

    submitApplication(){
        this.on_submit = true;
        this.onlineApplicationService.submitOnlineRegistration({post_type : "submit_application", online_registartion_form : this.OnlineApplicationForm.value}).subscribe(response=>{
            this.uploadImages(response["id"],response["message"])
        },error=>{
            this.on_submit = false;
            this.updateDate("revoke");
            this.toastr.error(error.error["message"])
        })
    }


    async uploadImages(id,message){
        this.document_length = this.student_form_image.length;
        if (this.document_length == 0) {
            this.uploadFormFiles(id, message)
        }
        else{
            const that = this;
            for (let index = 0; index < this.student_form_image.length; index++) {
                var uploadData = new FormData();
                uploadData.append('id',id);
                uploadData.append('post_type', "application_form_images");
                uploadData.append('key', this.student_form_image[index]['key']);
                uploadData.append('file', this.student_form_image[index]['value']);
                let response  =  await this.onlineApplicationService.submitOnlineRegistration(uploadData).toPromise().catch((error)=>
                    {
                        this.progress = this.progress + 1;
                        this.toastr.error(this.translate.instant(error['error']));
                    })
                ;
                if(response){
                    this.progress = this.progress + 1;
                }
            }
            this.fileUploadTimer = setInterval(function () {
                if (that.progress === that.document_length) {
                    clearInterval(that.fileUploadTimer)
                    that.uploadFormFiles(id,message)
                }
            }, 1000);
        }
    }

    async uploadFormFiles(id,message){
        this.document_length = this.admission_files.length;
        this.progress = 0;
        if (this.document_length == 0) {
            this.formSuccessfullComplete(message)
        }
        else{
            const that = this;
            for (let index = 0; index < this.admission_files.length; index++) {
                var uploadData = new FormData();
                uploadData.append('id',id);
                uploadData.append('post_type', "application_form_files");
                uploadData.append('file_name', this.admission_files.at(index).value['file_name']);
                uploadData.append('priority', this.admission_files.at(index).value['priority']);
                uploadData.append('mandatory', this.admission_files.at(index).value['mandatory']);
                uploadData.append('file', this.admission_files.at(index).value['file']);
                uploadData.append('filename', this.admission_files.at(index).value['filename']);
                let response  =  await this.onlineApplicationService.submitOnlineRegistration(uploadData).toPromise().catch((error)=>
                    {
                        this.progress = this.progress + 1;
                        this.toastr.error(this.translate.instant(error['error']));
                    })
                ;
                if(response){
                    this.progress = this.progress + 1;
                }
            }
            this.formfileUploadTimer = setInterval(function () {
                if (that.progress === that.document_length) {
                    clearInterval(that.formfileUploadTimer)
                    that.formSuccessfullComplete(message)
                }
            }, 1000);
        }
    }

    closeForm(){
        this.router.navigate(['school_application_form'])
    }

    ngOnInit() {
        let student_class_param = this.route.snapshot.queryParamMap.get('student_class');
        let student_dob_param = this.route.snapshot.queryParamMap.get('student_dob');
        if(!student_class_param || !student_dob_param){
            Swal.fire({
                icon: 'error',
                text: this.translate.instant("Something went wrong. Please Try again"),
                confirmButtonText: 'Okay'
            })
            this.router.navigate(['/school_application_form/'])
        }else{
            this.OnlineApplicationForm.patchValue({
                student_dob: student_dob_param,
                student_class : student_class_param
            })
        }
        this.getAdmissionEnable();
        setInterval(() => this.callNextSlide(), 18000);
    }

    getAdmissionEnable(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form", type : 'admission_status'}).subscribe(response=>{
            this.admission_status = response["data"]
            if(this.admission_status["status"]){
                this.checkStudentAgeValidity();
                this.getAdmissionDetails();
                this.getAdmissionFormFields();
                this.getAdmissionFormFiles();
                this.getSchoolLogo();
                this.getSliderImages();
                this.getNationality();
                this.getRelationships();
                this.getReligions();
                this.getCountries();
                this.getStates();
                this.getDistrict();
                this.getCitytown();
            }else{
                Swal.fire({
                    icon: 'error',
                    text: this.translate.instant("Admission is Closed!"),
                    confirmButtonText: 'Okay'
                })
                this.router.navigate(['/school_application_form/'])
            }
        })
    }

    checkStudentAgeValidity(){
        this.onlineApplicationService.checkOnlineApplicationInfos({
            student_class : this.OnlineApplicationForm.value["student_class"],
            student_dob : this.formatDate(this.OnlineApplicationForm.value["student_dob"]),
            type : "application_class_age",
            post_type : "application_form_settings"
        }).subscribe(response=>{
            if(response["status"] == 1){
            }else{
                Swal.fire({
                    icon: 'error',
                    text: this.translate.instant(response["message"]),
                    confirmButtonText: 'Okay'
                })
                 this.router.navigate(['/school_application_form/'])
            }
        },error=>{this.toastr.error(error.error["message"])})
        
    }

    getAdmissionDetails(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form", type : 'admission_details'}).subscribe(response=>{
            this.admission_details = response["data"]
        })
    }

    getSchoolLogo(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form", type : 'school_logo'}).subscribe(response=>{
            this.school_logo = response["data"]
        })
    }

    getSliderImages(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form",  type : "slider_images"}).subscribe(response=>{
            this.images = response["data"];
            if(this.images.length > 0){
                this.currentSlide = 0
                this.enable_image_view = true;
            }
        })
    }


    getNationality(){
        this.onlineApplicationService.getSystemConfigs({search_type : "system_config", type : 'nationality'}).subscribe(response=>{
            this.nationalites = response["data"];
        }, error=>{this.toastr.error(error.error["message"])})
    }

    getRelationships(){
        this.onlineApplicationService.getSystemConfigs({search_type : "system_config", type : 'relation'}).subscribe(response=>{
            this.relations = response["data"];
        }, error=>{this.toastr.error(error.error["message"])})
    }

    getReligions(){
        this.onlineApplicationService.getSystemConfigs({search_type : "system_config", type : 'religion'}).subscribe(response=>{
            this.religions = response["data"];
        }, error=>{this.toastr.error(error.error["message"])})
    }

    getCountries(){
        this.onlineApplicationService.getSystemConfigs({search_type : "system_config", type : 'country'}).subscribe(response=>{
            this.countries = response["data"];
        }, error=>{this.toastr.error(error.error["message"])})
    }

    getStates(){
        this.onlineApplicationService.getSystemConfigs({search_type : "system_config", type : 'state'}).subscribe(response=>{
            this.states = response["data"];
        }, error=>{this.toastr.error(error.error["message"])})
    }

    getDistrict(){
        this.onlineApplicationService.getSystemConfigs({search_type : "system_config", type : 'district'}).subscribe(response=>{
            this.districts = response["data"];
        }, error=>{this.toastr.error(error.error["message"])})
    }

    getCitytown(){
        this.onlineApplicationService.getSystemConfigs({search_type : "system_config", type : 'citytown'}).subscribe(response=>{
            this.cities = response["data"];
        }, error=>{this.toastr.error(error.error["message"])})
    }


    getAdmissionFormFields(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form", type : 'admission_fields'}).subscribe(response=>{
            this.admission_form_field_keys = response["admission_keys"];
            this.admission_form_fields = response["data"];
            this.loaded = true;
        })
    }
    

    getAdmissionFormFiles(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form", type : 'admission_files'}).subscribe(response=>{
            for(let admission_file of response["data"]){
                this.admission_files.push(
                    this.fb.group({
                        file_name : [admission_file["file_name"]],
                        priority : [admission_file["priority"]],
                        mandatory : [admission_file["mandatory"]],
                        file : [""],
                        filename : [""]
                    })
                )
            }
        })
    }

    ngOnDestroy(): void { 
        clearInterval(this.formfileUploadTimer);
        clearInterval(this.fileUploadTimer);
    }

    checkPhotoSectionEnabled(type){
        return this.admission_form_fields.some((dict) => dict.hasOwnProperty("field_key") && dict["field_key"] === type);
    }


    onFileChange(event, type){
        let selectedFile = event.target.files[0]
        if (selectedFile.size >=5200000) {
            this.toastr.error(this.translate.instant('File size must be less than 5 MB'));
            return ;
        }
        let i =0;
        for(let form_photo of this.student_form_image){
            if(form_photo["key"] == type){
                this.student_form_image.splice(i,1);
            }
            i = i+1;
        }
        let reader = new FileReader();
        reader.readAsDataURL(selectedFile); // read file as data url
        reader.onload = (event: any) => { // called once readAsDataURL is completed
            this.student_form_image_priview[type] = event.target.result
        }
        this.student_form_image.push({"key": type, "value" : selectedFile, filename : selectedFile.name})
    }

    onApplicationFileChange(event,i){
        let selectedFile = event.target.files[0]
        if (selectedFile.size >= 5200000) {
            this.toastr.error(this.translate.instant('File size must be less than 5 MB'));
            return ;
        }
        this.admission_files.at(i).patchValue({
            file : selectedFile,
            filename : selectedFile.name
        })

    }

    removeImage(type){
        let i =0;
        for(let form_photo of this.student_form_image){
            if(form_photo["key"] == type){
                this.student_form_image.splice(i,1);
            }
            i = i+1;
        }
        this.student_form_image_priview[type] = null;
    }



}
